<template>
    <div class="progress progress-striped active">
      <div role="progressbar progress-striped" class="progress-bar"><span class="text-transparent">Error...</span></div>
    </div>
</template>

<script>
export default {
    name: 'LoadingBar'
}
</script>

<style lang="scss" scoped>
.progress {
  @apply fixed top-0 z-30 bg-gray-200 w-full text-center text-white h-3;
  border-radius: 3px;
  box-shadow:none;
}

.progress-bar {
  @apply bg-error w-full absolute h-3;
  box-shadow: none;
}

@mixin gradient-striped($color: rgba(255,255,255,.15), $angle: 45deg) {
  background-image: linear-gradient($angle, $color 25%, transparent 25%, transparent 50%, $color 50%, $color 75%, transparent 75%, transparent);
}

@keyframes progress-bar-stripes {
  from    { background-position: 0 0; }
  to  { background-position: 40px 0; }
}

@mixin animation($animation) {
    animation: $animation;
}

.progress.active .progress-bar,
.progress-bar.active {
  @include animation(progress-bar-stripes .3s linear infinite);
}
.progress-striped .progress-bar,
.progress-bar-striped {
  @include gradient-striped;
  background-size: 40px 40px;
}
@mixin progress-bar-variant($color) {
  background-color: $color;
}
</style>